module.exports = "../images/green-tick.png";